import { render } from "./Service.vue?vue&type=template&id=7354d40c&scoped=true"
import script from "./Service.vue?vue&type=script&lang=js"
export * from "./Service.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7354d40c"

export default script